import React from 'react'

export function HistoryIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#C3CEDC"
        fillRule="evenodd"
        d="M2.91 2.614a.75.75 0 01.75.75V6.25h2.886a.75.75 0 010 1.5H2.909A.75.75 0 012.16 7V3.364a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill="#C3CEDC"
        fillRule="evenodd"
        d="M2.69 6.623A10.746 10.746 0 0112 1.25c5.937 0 10.75 4.813 10.75 10.75S17.937 22.75 12 22.75 1.25 17.937 1.25 12a.75.75 0 011.5 0 9.25 9.25 0 101.238-4.625.75.75 0 11-1.299-.752z"
        clipRule="evenodd"
      />
      <path
        fill="#C3CEDC"
        fillRule="evenodd"
        d="M12.003 5.25a.75.75 0 01.75.75l-.001 5.694 4.02 4.02a.75.75 0 11-1.06 1.06l-4.24-4.24a.75.75 0 01-.22-.53V6a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  )
}
